import { render, staticRenderFns } from "./AllTips.vue?vue&type=template&id=4deffaf0&"
import script from "./AllTips.vue?vue&type=script&lang=js&"
export * from "./AllTips.vue?vue&type=script&lang=js&"
import style0 from "./AllTips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports